var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "internal-page-main-section survey-section-main col-12" },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "survey-main-section col-12 float-l" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", {}, [
                  _vm.s3Initial != ""
                    ? _c(
                        "video",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { controls: "controls", preload: "metadata" }
                        },
                        [
                          _c("source", {
                            attrs: {
                              src:
                                _vm.s3Initial +
                                "our_story/VelocityVehicleGroupVVGAboutUs.mp4#t=0.1",
                              type: "video/mp4"
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v("Our Story")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08126bd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08126bd2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurStories.vue
// module id = null
// module chunks = 